import { BrowserRouter, Route, Routes } from "react-router-dom";
import React from "react";
import ReactDOM from "react-dom/client";
import { ThemeProvider } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import "./index.css";
import theme from "./theme";
import Home from "./pages/Home";
import Dictionary from "./pages/Dictionary";
import Mypage from "./pages/Mypage";
import Quiz from "./pages/Quiz";
import QuizMistakes from "./pages/QuizMistakes";
import reportWebVitals from "./reportWebVitals";
import { UserRegistrationProvider } from "./providers/UserRegistrationProvider";
import RegistrationModal from "./components/registration/RegistrationModal";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

// ホーム(/)とクイズはログイン不要。辞書とMyPageはページ側で
// 明示的なログインボタンを出し、押されたときだけliffClient.ensureLiffInit() /
// liff.login() を呼ぶ(自動リダイレクトはしない)。
root.render(
  <React.StrictMode>
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <UserRegistrationProvider>
        <RegistrationModal />
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/dictionary" element={<Dictionary />} />
            <Route path="/mypage" element={<Mypage />} />
            <Route path="/quiz" element={<Quiz />} />
            <Route path="/quiz/mistakes" element={<QuizMistakes />} />
          </Routes>
        </BrowserRouter>
      </UserRegistrationProvider>
    </ThemeProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
